const Footer = () => {
  return (
    <footer className="bg-black text-slate-400 text-left">
      <div className="container mx-auto max-w-screen-xl px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
              Peta Situs
            </p>
            <ul className="space-y-2.5">
              {[
                { label: "Perjanjian Klien", href: "#" },
                { label: "Kebijakan AML", href: "#" },
                { label: "Pusat bantuan", href: "#" }
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-slate-400 hover:text-slate-200 transition-colors text-sm"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
              Kontak
            </p>
            <div className="space-y-2 text-sm text-slate-400">
              <a
                href="mailto:support@stockity.id"
                className="hover:text-slate-200 transition-colors"
              >
                support@stockity.id
              </a>
              <p>
                Caracol Ltd.<br />
                <span className="text-slate-500">
                  Trust Company Complex, Ajeltake Road, Ajeltake Island, Majuro, Kepulauan Marshall, MH96960
                </span>
              </p>
              <p>No.Reg. 114137</p>
            </div>
          </div>
        </div>

        <div className="mb-10 max-w-3xl text-left">
          <p className="text-sm text-slate-500 leading-relaxed mb-3 text-left">
            Stockity memberikan layanan hanya kepada pengguna dewasa. Trading online dapat melibatkan risiko keuangan tinggi termasuk kehilangan semua dana di akun trading Anda. Harap pelajari semua risiko dan mintalah saran dari penasihat keuangan independen sebelum menggunakan layanan Stockity. Kami juga merekomendasikan untuk tidak menginvestasikan dana yang tidak Anda sanggup menanggungnya.
          </p>
          <p className="text-sm text-slate-600 leading-relaxed text-left">
            Stockity tidak bertanggung jawab untuk segala kerugian (langsung atau tidak langsung, atau konsekuensial) yang diakibatkan oleh tindakan klien di platform ini.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-8">
          <a
            href="#"
            className="text-sm text-slate-500 hover:text-slate-300 transition-colors"
          >
            Kebijakan Privasi
          </a>
          <p className="text-sm text-slate-600">
            © 2022–2025 Stockity. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
